import { render, staticRenderFns } from "./ApexChartExpenseRatio.vue?vue&type=template&id=c4355416&"
import script from "./ApexChartExpenseRatio.vue?vue&type=script&lang=js&"
export * from "./ApexChartExpenseRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports